import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Card,
  IconButton,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { useNavigate, useParams } from "react-router-dom";
import {

  useDeleteByIdSubscriptionMutation,
  useEditSubscriptionMutation,
  useGetAllSubscriptionQuery,
} from "../../services/subscription";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import Loader from "../../helpers/constants/Loader";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import EditKeyModal from "../../components/EditWarnModal";



const ManageSubscription = () => {
  const navigate = useNavigate();
  const [rows1, setRows1] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState<string>("")
  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [deleteSubscriptionById] = useDeleteByIdSubscriptionMutation();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [editSubscriptionbyId] = useEditSubscriptionMutation();
  let totalPages = Math.ceil(totalCount / limit);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows1([]);
  };
  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split('.');
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
    return result;
  }
  const {
    data,
    isError,
    isLoading: load,
    isSuccess,
  } = useGetAllSubscriptionQuery({
    page: page,
    search: debouncedSearchTerm.trim(),
    limit: limit,
    subscriptionPack: filter
  });

  const handleReceiverChange = async (event: any, userId: any) => {
    let body = {
      isBlocked: event.target.value === "1" ? false : true,
    };
    try {
      setIsLoading(true);

      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await editSubscriptionbyId({
        body: encryptedBody,
        id: userId,
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        successToast("Activation Status changed successfully");
        // setTimeout(() => {
        //   fetchData(page, searchTerm);
        // }, 100)
      }
    } catch (error: any) {
      setIsLoading(false);

      errorToast(error?.data?.message || "");
    }
  };


  const handleDeleteSubscription = async (userId: any) => {
    try {
      const response = await deleteSubscriptionById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Subscription deleted successfully");
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message || "");
    }
  };

  const naviagteFun = () => {
    navigate(
      `/manage-subscription/edit/${selectedId}`,
      {
        state: { type: "edit" },
      }
    )
  }

  useEffect(() => {
    if (isSuccess && data) {
      const res = data?.data;
      setRows1(res?.subscription || []);
      setTotalCount(res?.count);
    }
  }, [isSuccess, data]);

  return (
    <div>
      <Loader isLoad={isLoading || load} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Subscription</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                    setTimeout(() => {
                      setPage(1)
                    }, 1000)
                  }
                }}
              />

              <Select
                className="childFilter"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                displayEmpty
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250, // Adjust height
                      width: 200,     // Adjust width
                    },
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Subscription Type
                </MenuItem>
                <MenuItem value="1" >
                  Monthly
                </MenuItem>
                <MenuItem value="3" >
                  Quarterly
                </MenuItem>
                <MenuItem value="12" >
                  Yearly
                </MenuItem>


              </Select>
              {filter !== "" ? (
                <Button className="btn btn_primary"
                  style={{ backgroundColor: "black", marginLeft: "15px" }}
                  onClick={() => { setFilter(""); }}>
                  Clear filter
                </Button>
              ) : ("")}
            </Box>
            <Box className="cards_header_right">
              <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-subscription/add")}
              >
                <AddIcon />
                Add Subscription
              </Button>
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="center">Actions</TableCell>
                  <TableCell>Subscription Name</TableCell>
                  <TableCell>Subscription type</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Validity</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell>No. of agents</TableCell>
                  <TableCell>Company Status</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date & time</TableCell>
                  <TableCell>Enable/Disable</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows1.length === 0 ? (
                  <TableCell colSpan={10} align="center">
                    No subscription found
                  </TableCell>
                ) : (
                  rows1.map((row: any, i: any) => (
                    <TableRow key={row.i}>
                      <TableCell align="center">{(page - 1) * 10 + i + 1}</TableCell>
                      <TableCell>
                        <Box className="table_actions">
                          <IconButton
                            onClick={() =>
                              navigate(
                                `/manage-subscription/details/${row?._id}`
                              )
                            }
                          >
                            <VisibilityIcon />
                          </IconButton>

                          <IconButton

                            onClick={() => {
                              setOpenEdit(true);
                              setSelectedId(row?._id);
                            }}
                          >
                            <ModeEditIcon />
                          </IconButton>


                          <IconButton
                            onClick={() => {
                              setOpen(true);
                              setSelectedId(row?._id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>{row?.name || "-"}</TableCell>
                      <TableCell>
                        {row?.subscriptionPack == "1"
                          ? "Monthly"
                          : row?.subscriptionPack == "3"
                            ? "Quarterly"
                            : row?.subscriptionPack == "6"
                              ? "Half-Yearly"
                              : row?.subscriptionPack == "12"
                                ? "Yearly"
                                : "-"}
                      </TableCell>
                      <TableCell>
                        <Typography variant="h6" fontSize={14}>
                          {row?.price ? formatNumberWithCommas(String(row?.price)) : "-"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        {row?.subscriptionPack == "1"
                          ? "1 month"
                          : row?.subscriptionPack == "3"
                            ? "3 months"
                            : row?.subscriptionPack == "6"
                              ? "6 months"
                              : row?.subscriptionPack == "12"
                                ? "1 year"
                                : "-"}
                      </TableCell>
                      <TableCell>
                        {/* <Typography > */}
                        {row?.userId?.companyName ? row?.userId?.companyName + " (" + row?.userId?.referenceId + ")" : "-"}
                        {/* </Typography> */}
                      </TableCell>
                      <TableCell>{row?.noOfAgents || "-"}</TableCell>
                      <TableCell>{row?.subscriptionExpiry?.isActive ? "Active" : "Inactive"}</TableCell>
                      <TableCell>
                        {row?.subscriptionExpiry?.subscriptionEndDate && moment(row?.subscriptionExpiry?.subscriptionEndDate).isAfter(moment.utc()) ? "Live" : row?.subscriptionExpiry?.subscriptionEndDate && moment(row?.subscriptionExpiry?.subscriptionEndDate).isBefore(moment.utc()) ? "Expired" : "-"}
                      </TableCell>
                      <TableCell>{row?.createdAt ? moment(row?.createdAt).format("LLL") : "-"}</TableCell>
                      <TableCell>
                        <Select
                          fullWidth
                          className="select_div reqst_Select"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={row?.isBlocked ? "2" : "1"}
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          onChange={(e: any) => {
                            setSelectedId(row?._id);
                            handleReceiverChange(e, row?._id);
                          }}
                        >
                          <MenuItem value="1">Enable</MenuItem>
                          <MenuItem value="2">Disable</MenuItem>
                        </Select>
                      </TableCell>

                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {
        rows1?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows1}
            limit={limit}
            setLimit={setLimit}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )
      }
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteSubscription(selectedId)}
        name="Subscription"
      />
      <EditKeyModal
        open={openEdit}
        setOpen={setOpenEdit}
        navigate={naviagteFun}
      />
    </div >
  );
};

export default ManageSubscription;
